var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreeningsVaccines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65.6 65",
    style: {
      enableBackground: "new 0 0 65.6 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E3F2FF;}\n\t.st1{fill:#4343B5;}\n\t.st2{fill:#A6A6F7;}\n\t.st3{fill:#7ADDB6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1039_1_",
    transform: "translate(-878.782 -897.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_397_1_",
    transform: "translate(889.782 902.826)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    className: "st0",
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,10H1c-0.6,0-1-0.4-1-1V1c0-0.6,0.4-1,1-1h8c0.6,0,1,0.4,1,1v8C10,9.6,9.6,10,9,10z M2,8h6V2H2V8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_396_1_",
    transform: "translate(883.782 897.826)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2,1h18c0.6,0,1,0.4,1,1v3c0,0.6-0.4,1-1,1H2C1.4,6,1,5.6,1,5V2C1,1.4,1.4,1,2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,7H2C0.9,7,0,6.1,0,5V2c0-1.1,0.9-2,2-2h18c1.1,0,2,0.9,2,2v3C22,6.1,21.1,7,20,7z M2,2L2,2v3h18V2H2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_398_1_",
    transform: "translate(878.782 908.826)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2,1h28c0.6,0,1,0.4,1,1v4c0,0.6-0.4,1-1,1H2C1.4,7,1,6.6,1,6V2C1,1.4,1.4,1,2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,8H2C0.9,8,0,7.1,0,6V2c0-1.1,0.9-2,2-2h28c1.1,0,2,0.9,2,2v4C32,7.1,31.1,8,30,8z M2,2L2,2v4h28V2H2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_399_1_",
    transform: "translate(882.782 914.826)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,1h20c0.6,0,1,0.4,1,1v29c0,2.2-1.8,4-4,4H5c-2.2,0-4-1.8-4-4V2C1,1.4,1.4,1,2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,36H5c-2.8,0-5-2.2-5-5V2c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v29C24,33.8,21.8,36,19,36z M2,2L2,2v29 c0,1.7,1.3,3,3,3h14c1.7,0,3-1.3,3-3V2H2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_400_1_",
    transform: "translate(887.782 948.826)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,1h10c0.6,0,1,0.4,1,1v3c0,1.1-0.9,2-2,2H3C1.9,7,1,6.1,1,5V2C1,1.4,1.4,1,2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11,8H3C1.3,8,0,6.7,0,5V2c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v3C14,6.7,12.7,8,11,8z M2,2L2,2v3 c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V2H2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_408_1_",
    transform: "translate(891.782 954.826)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2,1h2c0.6,0,1,0.4,1,1v3c0,1.1-0.9,2-2,2l0,0C1.9,7,1,6.1,1,5V2C1,1.4,1.4,1,2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3,8C1.3,8,0,6.7,0,5V2c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2v3C6,6.7,4.7,8,3,8z M2,2L2,2v3c0,0.6,0.4,1,1,1 s1-0.4,1-1V2H2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1037_1_",
    transform: "translate(900.55 906.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1033_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_797_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.1,0c-5.9,0-10.7,5.1-10.7,11.4C21.4,5.1,16.6,0,10.7,0S0,5.1,0,11.4c0,12.2,15.7,22.4,20.2,25.1 c0.7,0.4,1.6,0.4,2.4,0c4.5-2.7,20.2-12.9,20.2-25.1C42.8,5.1,38,0,32.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.4,37.8c-0.6,0-1.2-0.2-1.7-0.5C14.8,34.4-1,24-1,11.4C-1,4.5,4.2-1,10.7-1c4.8,0,8.9,3,10.7,7.4 C23.2,2,27.3-1,32.1-1c6.5,0,11.7,5.5,11.7,12.4c0,12.7-15.8,23.1-20.7,26C22.6,37.6,22,37.8,21.4,37.8z M10.7,1 C5.3,1,1,5.6,1,11.4C1,23,16.1,32.9,20.7,35.6c0.4,0.3,0.9,0.3,1.3,0c4.6-2.8,19.7-12.6,19.7-24.2C41.8,5.6,37.4,1,32.1,1 s-9.7,4.6-9.7,10.4c0,0.6-0.4,1-1,1s-1-0.4-1-1C20.4,5.6,16,1,10.7,1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_798_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.8,20.4h-8.5c-1.2,0.1-2.1,0.9-2.4,2.1l-1,2.5l-2.4-9.2c-0.2-0.7-0.6-1.1-1.1-1.1s-0.9,0.5-1.1,1.2 L20,27.2l-2.4-15c-0.1-0.8-0.6-1.3-1.1-1.4s-1,0.5-1.1,1.3l-1.2,6.6c-0.2,1-0.8,1.7-1.5,1.7H3.9c0,0,0.7,1.1,1.4,2.1h7.3 c1.3,0,2.4-1.3,2.8-3.2l1.1-5.7l2.4,15c0.1,0.8,0.6,1.3,1.1,1.4l0,0c0.5,0,0.9-0.5,1.1-1.3l2.3-11.4l2.3,9c0.1,0.5,0.5,1,1,1.1 c0.4,0.1,0.8-0.3,1.1-0.8l1.2-2.9c0.2-0.6,0.7-1,1.3-1.1h6.9C37.8,22.1,38.5,21.1,38.8,20.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Line_81_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M890.3,950.3c-0.6,0-1-0.4-1-1v-28c0-0.6,0.4-1,1-1l0,0c0.6,0,1,0.4,1,1v27.9 C891.3,949.8,890.9,950.3,890.3,950.3L890.3,950.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_801_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M896.3,926.5h-5.5c-0.6,0-1-0.4-1-1s0.4-1,1-1h5.5c0.6,0,1,0.4,1,1S896.8,926.5,896.3,926.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_802_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M896.3,932.8h-5.5c-0.6,0-1-0.4-1-1s0.4-1,1-1h5.5c0.6,0,1,0.4,1,1S896.8,932.8,896.3,932.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_803_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M896.3,939.2h-5.5c-0.6,0-1-0.4-1-1s0.4-1,1-1h5.5c0.6,0,1,0.4,1,1S896.8,939.2,896.3,939.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_804_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M896.3,945.6h-5.5c-0.6,0-1-0.4-1-1s0.4-1,1-1h5.5c0.6,0,1,0.4,1,1S896.8,945.6,896.3,945.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreeningsVaccines);
export default __webpack_public_path__ + "static/media/screenings-vaccines.414d201a64a5297d8ae896c298f06214.svg";
export { ForwardRef as ReactComponent };